import { CLAN_API_SEARCH_FILTER, CLAN_PERSONAL_SEARCH_FILTER, CLAN_SEARCH_FILTER } from "@acme/constants";
import { createFileRoute } from "@tanstack/react-router";
import ClanApiSearchFilterFormFields from "~/features/clan-search-filters/_components/clan-api-search-filter-form-fields.js";
import ClanGlobalSearchFilterFormFields from "~/features/clan-search-filters/_components/clan-global-search-filter-form-fields.js";
import ClanPersonalSearchFilterFormFields from "~/features/clan-search-filters/_components/clan-personal-search-filter-form-fields.js";
import ActiveSearchStatusToggle from "~/features/clan-search-filters/_components/active-search-status-toggle.js";
import SearchFilterTabPage from "~/features/search-filters/_components/search-filter-tab-page.js";
import { useClanSearchAuth } from "../route.js";

export const Route = createFileRoute("/_authed/my-clans/$tag/player-search/filters")({
  component: ClanSearchFiltersPage,
});

function ClanSearchFiltersPage() {
  const { auth, isReady, effectivePermissions, userIsOwner } = useClanSearchAuth();

  if (!isReady || auth == null) return null;

  const canUpdateSearchStatus = userIsOwner || effectivePermissions.updateClanSearchFilter;

  return (
    <div className="space-y-6">
      <ActiveSearchStatusToggle
        canUpdate={canUpdateSearchStatus}
        clanTag={auth.clanTag}
        playerTag={auth.playerTag}
      />
      <SearchFilterTabPage
        auth={auth}
        enabled
        modelX={CLAN_SEARCH_FILTER}
        renderChildFormFields={{
          api: (form) => (
            <ClanApiSearchFilterFormFields
              control={form.control}
              getValues={form.getValues}
              setValue={form.setValue}
            />
          ),
          personal: (form) => <ClanPersonalSearchFilterFormFields control={form.control} />,
        }}
        renderFormFields={(form, helpers) => (
          <ClanGlobalSearchFilterFormFields
            auth={auth}
            control={form.control}
            isDeletingChild={helpers?.isDeletingChild}
            onCreateApiFilter={
              helpers != null ? () => helpers.openChildCreate(CLAN_API_SEARCH_FILTER) : undefined
            }
            onCreatePersonalFilter={
              helpers != null ? () => helpers.openChildCreate(CLAN_PERSONAL_SEARCH_FILTER) : undefined
            }
            onDeleteApiFilter={
              helpers != null
                ? (filterId) => void helpers.deleteChild(CLAN_API_SEARCH_FILTER, filterId)
                : undefined
            }
            onDeletePersonalFilter={
              helpers != null
                ? (filterId) => void helpers.deleteChild(CLAN_PERSONAL_SEARCH_FILTER, filterId)
                : undefined
            }
            onEditApiFilter={
              helpers != null
                ? (filterId) => helpers.openChildEdit(CLAN_API_SEARCH_FILTER, filterId)
                : undefined
            }
            onEditPersonalFilter={
              helpers != null
                ? (filterId) => helpers.openChildEdit(CLAN_PERSONAL_SEARCH_FILTER, filterId)
                : undefined
            }
          />
        )}
      />
    </div>
  );
}
